function closeBanner() {
  document.querySelectorAll('.js-banner').forEach(banner => {
    banner.style.display = 'none';
  });
}
